// Bridges the moment a photo capture sheet opens (field_photo_camera_controller.js)
// to the moment its resulting photo finishes compressing and starts upload
// (surveys/result_editor_controller.js#_logCaptureReturned) -- two different
// controllers with no reference to each other, connected only by the "Camera
// opened" -> loadFiles() -> onUploadFiles hand-off SurveyJS already provides.
//
// Card #4838: "Photo capture returned" gets cameraMs (Camera opened to Photo
// capture returned) and cameraMode ("native" | "in-app"). Named cameraMode
// rather than "mode" deliberately -- "Photo capture returned" already has a
// `mode` field meaning "background" | "awaited" (card #4097, see
// uploadSingleFile's call sites), so reusing the name would silently collide
// with an existing, tested meaning.
//
// Module-scoped singleton, same reasoning as field_battery_controller.js's
// lastReadingAtFallback: the photo camera sheet is a page-wide singleton too
// (its own header comment), so there's never more than one capture pending.

let pending = null

// Record that a capture sheet (or native handoff) just opened. mode is
// "native" or "in-app".
export function recordCameraOpened(mode) {
  pending = { mode, openedAt: performance.now() }
}

// Take (and clear) the pending record. One open pairs with the FIRST photo
// that returns from it -- a multi-photo sheet only logs "Camera opened" once
// per open(), so only the first capture in that batch carries cameraMs;
// later ones in the same batch get null rather than reusing a stale value.
// Returns null when nothing is pending (no Take Photo flow was used, e.g. a
// plain file-question upload).
export function takeCameraOpened() {
  const record = pending
  pending = null
  return record
}
